<template>
	<div>
		
				<div v-for="(item,itemIndex) in showdata" :key="itemIndex" class="o-f-h">
					<div class="whiteRaduisBox">
						<div class="borderBottom mb8">
							<div v-for="(data,perIndex) in item.nameList" class="blackFont plr4">{{data}}</div>
						</div>
						<div  class='flex mb8'  v-if="item.upper!==null">
							<span  class="blackFont plr4">上半工时</span>
<!--							<picker  :class="[' w-100',item.upper?'blackFont':'darkGrayFont']"mode="selector" @change="bcChange($event,itemIndex,'up')" :range="bcList" range-key="vc_bcname">-->
<!--								{{item.upper?item.upper.vc_bcnote:'请选择班次'}}-->
<!--								<uni-icons  class='rowRightIcon pL14' type="right"></uni-icons>-->
<!--							</picker>-->
							<el-select class="plr4" v-model="item.upperi_bcid" placeholder="请选择班次" size="mini" @change="bcChange(item,itemIndex,'up')">
								<el-option
										v-for="itemb in bcList"
										:key="itemb.i_bcid"
										:label="itemb.vc_bcname"
										:value="itemb.i_bcid">
								</el-option>
							</el-select>
							<el-checkbox-group :disabled="item.upper&&item.upper.i_isfourth==0" :min="1" v-model="item.upperi_fourthworkL" class="blackFont plr4">
								<el-checkbox v-for="(c,cindex) in item.uppertimeList" :key="c.value"  :label="c.value">{{c.text}}</el-checkbox>
							</el-checkbox-group>
<!--							<uni-data-checkbox :disabled="item.upper&&item.upper.i_isfourth==0" class='w100' :min="1" selectedColor="var(&#45;&#45;themeColor)" multiple v-model="item.upperi_fourthworkL" :localdata="item.uppertimeList" @change="change($event,itemIndex,'up')"></uni-data-checkbox>-->
						</div>
						<div  class='flex ' v-if="item.lower!==null">
							<span  class="blackFont plr4">下半工时</span>
							<el-select class="plr4" v-model="item.loweri_bcid" placeholder="请选择班次" size="mini" @change="bcChange(item,itemIndex,'low')">
								<el-option
										v-for="itemb in bcList"
										:key="itemb.i_bcid"
										:label="itemb.vc_bcname"
										:value="itemb.i_bcid">
								</el-option>
							</el-select>
							<el-checkbox-group :disabled="item.lower&&item.lower.i_isfourth==0" :min="1" v-model="item.loweri_fourthworkL" class="blackFont plr4" >
								<el-checkbox v-for="(c,cindex) in item.lowertimeList" :key="c.value" :label="c.value">{{c.text}}</el-checkbox>
							</el-checkbox-group>
<!--							<picker :class="[' w-100',item.lower?'blackFont':'darkGrayFont']" mode="selector" @change="bcChange($event,itemIndex,'low')" :range="bcList" range-key="vc_bcname">-->
<!--								{{item.lower?item.lower.vc_bcnote:'请选择班次'}}-->
<!--								<uni-icons  class='rowRightIcon pL14' type="right"></uni-icons>-->
<!--							</picker>-->
<!--							<uni-data-checkbox :disabled="item.lower&&item.lower.i_isfourth==0" :min="1" class='w100' selectedColor="var(&#45;&#45;themeColor)" multiple v-model="item.loweri_fourthworkL" :localdata="item.lowertimeList" @change="change($event,itemIndex,'low')"></uni-data-checkbox>-->
						</div>
					</div>
				</div>
		<div class="buttonRow center mTop14">
			<el-button class='popCancelBtn' @click="closepop" :disabled="disableCan" size="mini">取消</el-button>
			<el-button class='popSaveBtn' @click="saveSchedule" :disabled="disableCan" type="primary" size="mini">提交</el-button>
<!--			<el-button class="editButton" @click="save">保存班组</el-button>-->
<!--			<el-button class='popCancelBtn' @click="closepop" :disabled="disableCan">取消</el-button>-->
		</div>
		<div class="cusPage">
<!--			<uni-popup ref="savePop" class='pop' :mask-click='false'>-->
<!--				<div  class="titleTxt p9">保存班组</div>-->
<!--				<div class="blackFont">是否保存当前更改？</div>-->
<!--				<div class="mTop14">-->
<!--					<el-button class='popCancelBtn' @click="closepop" :disabled="disableCan">取消</el-button>-->
<!--					<el-button class='popSaveBtn' @click="saveSchedule" :disabled="disableCan">提交</el-button>-->
<!--				</div>-->
<!--			</uni-popup>-->
		</div>
	</div>
</template>

<script>
	import * as API from "./../api"
	import {mapActions} from "vuex";
	export default {
		props:{
			data:{
				type:Object,
				required:true
			}
		},
		data() {
			return {
				chooseList:[],
				scrollHeight: '',
				screenHeight: '',
				showup:[],
				showlow:[],
				showList:[],
				disableCan:false,
				showdata:[],
			}
		},
		mounted() {
			this.chooseList=JSON.parse(JSON.stringify(this.data.chooseList))
			this.bcList=JSON.parse(JSON.stringify(this.data.bcList))
			this.perList=this.chooseList.map(b=>b.i_uid)
			this.bcstringList=[];
			for(let i=0;i<this.perList.length;i++){
				let per=this.perList[i],bcarr=[],bcstring='';
				bcarr=this.chooseList.filter(c=>c.i_uid==per)
				for(let j=0;j<bcarr.length;j++){
					if(bcarr[j].i_whichhalf==0){
						bcstring=bcarr[j].i_bcid+'-'+bcstring
					}else{
						bcstring=bcstring+bcarr[j].i_bcid
					}
				}
				let data={};
				let iobj=this.bcstringList.findIndex(b=>b.bcstring==bcstring);
				if(iobj==-1){
					data={bcstring:bcstring,per:[per]}
					this.bcstringList.push(data)
				}else{
					let pobj=this.bcstringList[iobj].per.findIndex(p=>p==per)
					if(pobj==-1)this.bcstringList[iobj].per.push(per)
				}
				// this.bcstringList.push(data)
			}
			// this.bcstringList=Array.from(new Set(this.bcstringList));
			for(let i=0;i<this.bcstringList.length;i++){
				let bc=this.bcstringList[i],arr=[],bci;
					bci=bc.bcstring.indexOf('-');
				let u,l,hash={},lower,upper,scheduleList=[],nameList=[],loweri_fourthworkL=[],upperi_fourthworkL=[],loweri_bcid,upperi_bcid;
				if(bci==-1){
					l=bc.bcstring
					u=''
				}else{
					arr=bc.bcstring.split('-');
					u=arr[0]
					l=arr[1]
				}
				if(u){
					upper=this.bcList.find(b=>b.i_bcid==u)
					upperi_bcid=Number(u)
				}else if(u==''){
					upper=null
					upperi_bcid=null
				}else if(u==0){
					upper={
						i_isfourth:0
					}
					upperi_bcid=null
				}
				if(l){
					lower=this.bcList.find(b=>b.i_bcid==l)
					loweri_bcid=Number(l)
				}else if(l==''){
					lower=null
					loweri_bcid=null
				}else if(l==0){
					lower={
						i_isfourth:0
					}
					loweri_bcid=null
				}
				for(let j=0;j<bc.per.length;j++){
					let p=bc.per[j];
					let objList=this.chooseList.filter(c=>c.i_uid==p);
					for(let t=0;t<objList.length;t++){
						let obj=objList[t];
						if(nameList.findIndex(n=>n==obj.vc_uname)==-1){
							nameList.push(obj.vc_uname)
						}
						if(obj.i_whichhalf==0){
							scheduleList.unshift(obj)
							if(obj.i_fourthwork==1||obj.i_fourthwork==2){
								upperi_fourthworkL[0]=obj.i_fourthwork
							}else{
								if(obj.i_isfourth==0){
									upperi_fourthworkL=[1]
								}else{
									upperi_fourthworkL=[1,2]
								}
							}
						}else if(obj.i_whichhalf==1){
							scheduleList.push(obj)
							if(obj.i_fourthwork==1||obj.i_fourthwork==2){
								loweri_fourthworkL[0]=obj.i_fourthwork
							}else{
								if(obj.i_isfourth==0){
									loweri_fourthworkL=[2]
								}else{
									loweri_fourthworkL=[1,2]
								}
								// loweri_fourthworkL=[1,2]
							}
						}
					}

				}
				hash={
					upper:upper,
					upperi_bcid:upperi_bcid,
					uppertimeList:!upper?[]:upper.i_isfourth?[{
						value: 1,
						text: upper.dt_upperstart+'-'+upper.vc_upperbetween
					},{
						value: 2,
						text: upper.vc_upperbetween+'-'+upper.dt_upperend
					}]:[{
						value: 1,
						text: upper.dt_upperstart+'-'+upper.dt_upperend
					}],
					upperi_fourthworkL:upperi_fourthworkL,
					lower:lower,
					loweri_bcid:loweri_bcid,
					lowertimeList:!lower?[]:lower.i_isfourth?[{
						value: 1,
						text: lower.dt_lowerstart+'-'+lower.vc_lowerbetween
					},{
						value: 2,
						text: lower.vc_lowerbetween+'-'+lower.dt_lowerend
					}]:[{
						value: 2,
						text: lower.dt_lowerstart+'-'+lower.dt_lowerend
					}],
					loweri_fourthworkL:loweri_fourthworkL,
					scheduleList:scheduleList,
					nameList:nameList,
				}
				this.showdata.push(hash)
				// console.log(this.showdata,'this.showdata')
			}
			this.$nextTick(()=>{
				this.onResize();

			})
		},
		watch: {
			'$root.workSize':{
				handler(n,o) {
					this.onResize(n);
				},
				deep:true,
			},
		},
		activated(){
			this.onResize();
		},
		methods:{
			...mapActions(["getCurrentMenuId"]),
			onResize (n){
				if (n==undefined) n=this.$root.workSize;

				$("#homeBox").height(n.h);
				$("#homeBox").width(n.w);
				this.tableHeight= n.h-100

				// console.log(this.tableHeight)
				// $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
				// this.$refs.spread_Edit.onResize();
			},
			bcChange(item,index,type){
				if(type=='up'){
					let data=this.bcList.find(i=>i.i_bcid==item.upperi_bcid);
					this.showdata[index].upper=data
					this.showdata[index].uppertimeList=data.i_isfourth?[{
						value: 1,
						text: data.dt_upperstart+'-'+data.vc_upperbetween
					},{
						value: 2,
						text: data.vc_upperbetween+'-'+data.dt_upperend
					}]:[{
						value: 0,
						text: data.dt_upperstart+'-'+data.dt_upperend
					}]
					this.showdata[index].upperi_fourthworkL=data.i_isfourth?[1,2]:[0]
					this.$forceUpdate()
				}else{
					let data=this.bcList.find(i=>i.i_bcid==item.loweri_bcid);
					this.showdata[index].lower=data
					this.showdata[index].lowertimeList=data.i_isfourth?[{
						value: 1,
						text: data.dt_lowerstart+'-'+data.vc_lowerbetween
					},{
						value: 2,
						text: data.vc_lowerbetween+'-'+data.dt_lowerend
					}]:[{
						value: 0,
						text: data.dt_lowerstart+'-'+data.dt_lowerend
					}]
					this.showdata[index].loweri_fourthworkL=data.i_isfourth?[1,2]:[0]
					this.$forceUpdate()
				}
				// console.log(this.showdata,'e');
			},
			change(e,index,type){
				// console.log(e.detail.value,'e');
				// if(type=='up'){
				// 	if(e.detail.value.length==1){
				// 		this.showup[index].upper.i_fourthwork=e.detail.value[0]
				// 	}else if(e.detail.value.length==2){
				// 		this.showup[index].upper.i_fourthwork=0
				// 	}
				// 	this.$forceUpdate()
				// 	console.log(this.showup,'e');
				// }else{
				// 	if(e.detail.value.length==1){
				// 		this.showlow[index].lower.i_fourthwork=e.detail.value[0]
				// 	}else if(e.detail.value.length==2){
				// 		this.showlow[index].lower.i_fourthwork=0
				// 	}
				// 	this.$forceUpdate()
					
				// }
			},
			closepop(){
				this.$emit('close','back')

			},
			save(){
				this.saveSchedule()
			},
			async saveSchedule(){
				this.saveData=[]
				for(let i=0;i<this.showdata.length;i++){
					let hash={},data=this.showdata[i];
					// console.log(data,'data')
					// data.upper.i_fourthwork=data.i_fourthworkL.length==2?0:data.i_fourthworkL[0]
					if(data.upper===undefined){
						this.$message.warning('班次不得为空')
						return
						
					}else if(data.upper===null){
						
					}else{
						if(data.upperi_fourthworkL.length==0){
							this.$message.warning('班次不得为空')
							return
						}else{
							hash.upper=JSON.parse(JSON.stringify(data.upper))
							hash.upper.i_fourthwork=data.upperi_fourthworkL.length==2||data.upper.i_isfourth==0?0:data.upperi_fourthworkL[0]
							// console.log(hash.upper.i_fourthwork,'hash.upper.i_fourthwork',data.upperi_fourthworkL,data.lower.i_isfourth,'data.upperi_fourthworkL')
						}
					}
					// console.log(data.lower,'data.lower');
					if(data.lower===undefined){
						this.$message.warning('班次不得为空')
						return
					}else if(data.lower===null){
						
					}else{
						if(data.loweri_fourthworkL.length==0){
							this.$message.warning('班次不得为空')
							return
						}else{
							hash.lower=JSON.parse(JSON.stringify(data.lower))
							hash.lower.i_fourthwork=data.loweri_fourthworkL.length==2||data.lower.i_isfourth==0?0:data.loweri_fourthworkL[0]
							// console.log(hash.lower.i_fourthwork,'hash.lower.i_fourthwork',data.loweri_fourthworkL,data.lower.i_isfourth,'data.loweri_fourthworkL')

						}
						
					}
					hash.scheduleList=data.scheduleList
					this.saveData.push(hash)
				}
				// return
				this.disableCan=true
				let param ={ 
					data:this.saveData,
					}
				// this.otherParam=param;
				let res = await API.saveSchedule(param)
				if (res.code == 1) {
					// this.$message.warning(res.message)
					this.closepop()
					this.disableCan=false
					this.$emit('close','save')
				}else{
					this.$message.error(res.message)
					this.disableCan=false
				}
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.blackFont{
		display: inline-block;
	}
	.o-f-h{
		overflow: hidden;
	}
	.labelWidth{
		flex:0 0 65px;
	}
	.plr4{
		padding-left:4px ;
		padding-right:4px ;
	}
	.right{
		width: 100%;
		text-align: right;
	}
	.w100{
		width: 100%;
	}
	.w-100{
		width: 100px;
	}

	.btnRow{
		position:fixed;
		bottom:0
	}
	.mTop14{
		margin-top: 24px;
	}
	.pop el-button{
		background: none;
	}

	.borderBottom{
		border-bottom: 1px solid var(--lightGreyBorder);
	}
	.mb8{
		margin-bottom: 8px;
	}
	.center{
		text-align: center;
	}
	/deep/.el-checkbox__input.is-disabled+span.el-checkbox__label{
		color: #606266;
	}
	.el-checkbox__input.is-disabled+span.el-checkbox__label{
		color: #606266;
	}
</style>